import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react-analytics-charts/react-analytics-charts/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Props } from "docz";
import { AuthorizeButton } from "./AuthorizeButton";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1>AuthorizeButton</h1>
    <h2 {...{
      "id": "description"
    }}>{`Description`}</h2>
    <p>{`Renders a Google Analytics sign-in button allowing the user to sign in with their Google account.`}</p>
    <p>{`This component is rendered by the `}<a parentName="p" {...{
        "href": "https://justinmahar.github.io/react-use-analytics-api/"
      }}>{`Google Analytics Embed API`}</a>{` into a container on the page.`}</p>
    <p>{`After signing in, the `}<inlineCode parentName="p">{`onSignIn`}</inlineCode>{` handler is called. This handler can be used to update the view once signed in. The handler is not called if already signed in.`}</p>
    <p>{`To check if the user is already authorized, you can use the `}<a parentName="p" {...{
        "href": "https://justinmahar.github.io/react-use-analytics-api/useAnalyticsApi"
      }}><inlineCode parentName="a">{`useAnalyticsApi`}</inlineCode></a>{` hook. A full example is available below.`}</p>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://justinmahar.github.io/react-use-analytics-api/"
      }}>{`Google Analytics Embed API`}</a>{` will only render the sign-in button once per page load. A refresh button will be shown when the original button's container is disposed of by React. Clicking that button reloads the current page.`}</p>
    <p>{`This component wraps the `}<a parentName="p" {...{
        "href": "https://justinmahar.github.io/react-use-analytics-api/useAuthorize"
      }}><inlineCode parentName="a">{`useAuthorize`}</inlineCode></a>{` hook from `}<a parentName="p" {...{
        "href": "https://justinmahar.github.io/react-use-analytics-api/"
      }}>{`react-use-analytics-api`}</a>{`.`}</p>
    <p>{`See related `}<a parentName="p" {...{
        "href": "/react-analytics-charts/SignOutButton"
      }}>{`SignOutButton`}</a>{`.`}</p>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { AuthorizeButton } from "react-analytics-charts";
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<AuthorizeButton
  gapi={gapi}
  authOptions={{
    clientId:
      "123456789012-abc123def456ghi789jkl012mno345p.apps.googleusercontent.com",
  }}
  onSignIn={signInHandler}
/>
`}</code></pre>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <Props of={AuthorizeButton} mdxType="Props" />
    <blockquote>
      <p parentName="blockquote">{`Note: Expand each prop for more information.`}</p>
    </blockquote>
    <h2 {...{
      "id": "styling"
    }}>{`Styling`}</h2>
    <p>{`This component renders as either one or two divs, depending on if a refresh page button is visible.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`The authorize button is in a `}<inlineCode parentName="p">{`div`}</inlineCode>{` with the class name `}<inlineCode parentName="p">{`gapi-authorize-container`}</inlineCode>{`. Inspect the DOM to see what Google renders there.`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-css"
          }}>{`.gapi-authorize-container {
  /* Custom styles */
}
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li">{`The refresh `}<inlineCode parentName="p">{`button`}</inlineCode>{` is in a `}<inlineCode parentName="p">{`div`}</inlineCode>{` with the class name `}<inlineCode parentName="p">{`analytics-refresh-button-container`}</inlineCode>{`. This contains the `}<inlineCode parentName="p">{`button`}</inlineCode>{` element for refreshing the page.`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-css"
          }}>{`.analytics-refresh-button-container button {
  /* Custom styles */
}
`}</code></pre>
      </li>
    </ul>
    <h2 {...{
      "id": "example"
    }}>{`Example`}</h2>
    <p>{`Below is an example showing the full authorization flow from signed out to signed in, and vice versa.`}</p>
    <p>{`Although not necessary if using an `}<a parentName="p" {...{
        "href": "/react-analytics-charts/AnalyticsDashboard"
      }}>{`AnalyticsDashboard`}</a>{`, if you want, you can use the `}<a parentName="p" {...{
        "href": "https://justinmahar.github.io/react-use-analytics-api/useAnalyticsApi"
      }}><inlineCode parentName="a">{`useAnalyticsApi`}</inlineCode></a>{` hook to check if the user is authorized.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import * as React from "react";
import { useAnalyticsApi } from "react-use-analytics-api";
import { AuthorizeButton, SignOutButton } from "react-analytics-charts";

export function AuthExample() {
  const { gapi, authorized } = useAnalyticsApi();
  return (
    <div>
      {!authorized && (
        <div>
          Not authorized. Sign in here:{" "}
          <AuthorizeButton
            gapi={gapi}
            authOptions={{
              clientId:
                "123456789012-abc123def456ghi789jkl012mno345p.apps.googleusercontent.com",
            }}
          />
        </div>
      )}
      {authorized && (
        <div>
          We're authorized! <SignOutButton gapi={gapi} />
        </div>
      )}
    </div>
  );
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      